import React, { useContext } from 'react';
import '../css/odd-days.css'
import { functionContext } from '../app'

function OddDays({ monthUserEvents, nameToDisplay, dateToDisplay, ageToDisplay, zodiacToDisplay, isEditing, setisEditing, setnameToEdit, setdateToEdit, setidToEdit, currentMonth, currentYear }) {

// console.log(monthUserEvents)

  const { setnameToDisplay, setdateToDisplay, setageToDisplay, setzodiacToDisplay } = useContext(functionContext);

function handleMouseEnter(e) {
  e.currentTarget.style.color = 'white';
  e.currentTarget.style.backgroundColor = 'black';
  let nameText = document.getElementById('nameText')
  nameText.style.display = "block"
  // let dateText = document.getElementById('dateText')
  // dateText.style.display = "block"
  let ageText = document.getElementById('ageText')
  ageText.style.display = "block"
  // console.log(e.currentTarget.className)
  monthUserEvents.filter((x) => {
    if (x.event_id === +e.currentTarget.className) {
      let zodiacDay = x.event_date.substr(8 ,2)
      let zodiacMonth = x.event_date.substr(5 ,2)

      setnameToDisplay(x.event_name)
      // setdateToDisplay(x.event_date.substr(0, 10))
      setageToDisplay(x.current_age)
      setzodiacToDisplay(zodiac(+zodiacDay, +zodiacMonth))
      // console.log(x)
    }
    return x
  })
}

function handleMouseLeave(e) {
  e.currentTarget.style.color = 'black';
  e.currentTarget.style.backgroundColor = 'white'
  let nameText = document.getElementById('nameText')
  nameText.style.display = "none"
  // let dateText = document.getElementById('dateText')
  // dateText.style.display = "none"
  let ageText = document.getElementById('ageText')
  ageText.style.display = "none"

  setnameToDisplay("")
  setdateToDisplay("")
}

function enterEdit(e) {
  // console.log(e.currentTarget)
  monthUserEvents.filter((x) => {
    if (x.event_id === +e.currentTarget.className) {
      setnameToEdit(x.event_name)
      setdateToEdit(x.event_date.substr(0, 10))
      setidToEdit(x.event_id)
      // console.log(x.event_id)
      // console.log(x)
    }
    
  })

  if (isEditing === false) {
    setisEditing(true)
  }
  // setisEditing(true)
}

function zodiac(day, month){
  var zodiac =['', 'Capricorn', 'Aquarius', 'Pisces', 'Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 'Libra', 'Scorpio', 'Sagittarius', 'Capricorn'];
  var last_day =['', 19, 18, 20, 20, 21, 21, 22, 22, 21, 22, 21, 20, 19];
  return (day > last_day[month]) ? zodiac[month*1 + 1] : zodiac[month];
 }

 function daysInMonth (month, year) {
  return new Date(year, month, 0).getDate();
}

daysInMonth(currentMonth, currentYear)

  return (
    <>
    <div id="nameText" className="popo">{nameToDisplay} </div>
    {/* <div id="dateText" className="popo2">{dateToDisplay?.substr(0, 10)}</div> */}
    <div id="ageText" className="popo2">{`${ageToDisplay} old`}</div>
      <div id="odd-days">

          {
        [...Array(daysInMonth(currentMonth, currentYear))].map((_, i) =>
          <div className="days-odd" key={i}>
            {monthUserEvents?.filter(e => +e.event_date.slice(8, 10) === i + 1)
              .map((e, i) => <div 
              onMouseEnter={(e) => handleMouseEnter(e)} 
              onMouseLeave={(e) => handleMouseLeave(e)}
              onClick={(e) => enterEdit(e)}
              className={e.event_id} 
              key={i}>+</div>)
          }
            </div>
        )
          }

      </div>
    </>
  )
}

export default OddDays;
